(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmh-about-story"] && !Shopify.designMode) return;
  try {
    
  const storyReveals = document.querySelectorAll('.bmh-story__reveal');

  if ('IntersectionObserver' in window) {
    const storyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          storyObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    storyReveals.forEach((item) => storyObserver.observe(item));
  } else {
    storyReveals.forEach((item) => item.classList.add('is-visible'));
  }

  const initStoryLotties = (attempt = 0) => {
    const storyLotties = document.querySelectorAll('[data-bmh-lottie]');

    if (!window.lottie) {
      if (attempt < 20) window.setTimeout(() => initStoryLotties(attempt + 1), 100);
      return;
    }

    storyLotties.forEach((container) => {
      if (container.dataset.bmhLottieLoaded === 'true') return;

      container.dataset.bmhLottieLoaded = 'true';
      window.lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: container.dataset.animationUrl,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet',
        },
      });
    });
  };

  initStoryLotties();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-discount-popup"] && !Shopify.designMode) return;
  try {
    
  class NewsletterDiscountPopup extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleDialogClose = this.handleDialogClose.bind(this);
      this.handleCopy = this.handleCopy.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleSectionSelect = this.handleSectionSelect.bind(this);
    }

    connectedCallback() {
      this.dialogComponent = this.querySelector('dialog-component');
      this.formState = this.querySelector('[data-form-state]')?.dataset.state || 'idle';
      this.designMode = this.dataset.designMode === 'true';
      this.abortController = new AbortController();

      this.dialogComponent?.addEventListener('dialog:close', this.handleDialogClose, {
        signal: this.abortController.signal,
      });
      this.querySelector('[data-copy-discount]')?.addEventListener('click', this.handleCopy, {
        signal: this.abortController.signal,
      });
      this.querySelector('form')?.addEventListener('submit', this.handleSubmit, {
        signal: this.abortController.signal,
      });
      this.querySelector('[data-discount-shop]')?.addEventListener(
        'click',
        () => this.track('welcome_discount_shop'),
        { signal: this.abortController.signal }
      );
      document.addEventListener('shopify:section:select', this.handleSectionSelect, {
        signal: this.abortController.signal,
      });

      customElements.whenDefined('dialog-component').then(() => this.initialize());
    }

    disconnectedCallback() {
      this.abortController?.abort();
      window.removeEventListener('scroll', this.handleScroll);
      window.clearTimeout(this.openTimer);
    }

    initialize() {
      if (!this.dialogComponent) return;

      // Shopify customer forms share the return-page success state. Only
      // claim the discount confirmation when this tab submitted our form.
      let discountSubmission = false;
      try {
        const submission = JSON.parse(sessionStorage.getItem('bmh-newsletter-submission'));
        discountSubmission = submission?.source === 'welcome-discount' &&
          Date.now() - submission.at < 30 * 60 * 1000;
      } catch (_error) {
        // Without a source marker, leave confirmation to the regular newsletter.
      }

      const newsletterSuccess = document.querySelector('[id^="Email-signup__message-success-"]') ||
        new URLSearchParams(window.location.search).get('customer_posted') === 'true';
      if (!discountSubmission && newsletterSuccess) {
        this.saveState('subscribed');
        return;
      }

      if (this.formState === 'success') {
        this.saveState('subscribed');
        if (!discountSubmission) return;
        this.track('welcome_discount_signup_success');
        this.show();
        return;
      }

      if (this.formState === 'error') {
        if (discountSubmission) this.show();
        return;
      }

      if (this.designMode) {
        this.openTimer = window.setTimeout(() => this.show(), 250);
        return;
      }

      if (this.dataset.alreadySubscribed === 'true' || this.isSuppressed()) return;

      const delay = Math.max(0, Number(this.dataset.delaySeconds) || 0) * 1000;
      this.openTimer = window.setTimeout(() => this.show(), delay);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.handleScroll();
    }

    handleScroll() {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight <= 0) return;

      const progress = (window.scrollY / scrollableHeight) * 100;
      if (progress >= (Number(this.dataset.scrollPercent) || 35)) this.show();
    }

    show() {
      if (this.hasShown || !this.dialogComponent?.showDialog) return;

      this.hasShown = true;
      window.clearTimeout(this.openTimer);
      window.removeEventListener('scroll', this.handleScroll);
      this.dialogComponent.showDialog();
      this.track('welcome_discount_view');
    }

    handleDialogClose() {
      if (!this.designMode && this.formState !== 'success') this.saveState('dismissed');
      this.track('welcome_discount_dismiss');
    }

    handleSubmit() {
      try {
        sessionStorage.setItem('bmh-newsletter-submission', JSON.stringify({
          source: 'welcome-discount', at: Date.now(),
        }));
      } catch (_error) {
        // Signup still works when browser storage is unavailable.
      }
      this.track('welcome_discount_submit');
    }

    handleSectionSelect(event) {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.hasShown = false;
        this.show();
      }
    }

    async handleCopy(event) {
      const button = event.currentTarget;
      const code = button.dataset.copyDiscount;

      try {
        await navigator.clipboard.writeText(code);
      } catch (_error) {
        const temporaryInput = document.createElement('textarea');
        temporaryInput.value = code;
        temporaryInput.setAttribute('readonly', '');
        temporaryInput.style.position = 'fixed';
        temporaryInput.style.opacity = '0';
        document.body.appendChild(temporaryInput);
        temporaryInput.select();
        document.execCommand('copy');
        temporaryInput.remove();
      }

      button.textContent = this.dataset.copiedLabel;
      this.track('welcome_discount_copy');
    }

    isSuppressed() {
      try {
        const saved = JSON.parse(localStorage.getItem(this.dataset.storageKey));
        if (!saved) return false;
        if (saved.state === 'subscribed') return true;
        if (saved.expiresAt && Date.now() < saved.expiresAt) return true;
        localStorage.removeItem(this.dataset.storageKey);
      } catch (_error) {
        return false;
      }

      return false;
    }

    saveState(state) {
      try {
        const value = { state };
        if (state === 'dismissed') {
          const days = Math.max(1, Number(this.dataset.dismissDays) || 30);
          value.expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
        }
        localStorage.setItem(this.dataset.storageKey, JSON.stringify(value));
      } catch (_error) {
        return;
      }
    }

    track(eventName) {
      this.dispatchEvent(
        new CustomEvent(eventName, {
          bubbles: true,
          detail: { sectionId: this.dataset.sectionId },
        })
      );

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, section_id: this.dataset.sectionId });
      }
    }
  }

  if (!customElements.get('newsletter-discount-popup')) {
    customElements.define('newsletter-discount-popup', NewsletterDiscountPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
